// Single (8×7) vs double (16×7) car-door size. Classification itself is server-authoritative (recovered
// from the detected quad's perspective projection); the client only carries the verdict + a manual
// override and maps a size to the door's feet dimensions for the catalogue/pricing/render calls.

export type DoorSize = "single" | "double";

export const sizeDims = (size: DoorSize): { width: number; height: number } =>
  size === "single" ? { width: 8, height: 7 } : { width: 16, height: 7 };

export const sizeLabel = (size: DoorSize): string => (size === "single" ? "Single" : "Double");
